"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.173 14.587a8.161 8.161 0 0 1-6.607 1.568 8.156 8.156 0 1 1 8.021-2.982l3.221 3.22a1 1 0 0 1-1.414 1.415l-3.221-3.22ZM4.736 3.037a6.156 6.156 0 0 1 7.862 9.382.994.994 0 0 0-.18.18 6.156 6.156 0 1 1-7.682-9.561Z",
    clipRule: "evenodd"
  })]
});